import React from 'react';
import { T, sx } from '../lib/tokens';
import { Wordmark } from '../components/ui/Wordmark';
import { XeroX } from '../components/ui/Icons';

const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export function Login() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: T.paper,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: '#FFFFFF',
          border: `1px solid ${T.paperLine}`,
          borderRadius: 16,
          padding: 48,
          textAlign: 'center',
        }}
      >
        <div style={{ marginBottom: 32 }}>
          <Wordmark size={36} color={T.graphite} />
        </div>

        <p
          style={{
            fontSize: 15,
            color: T.graphiteMuted,
            marginBottom: 32,
            lineHeight: 1.5,
          }}
        >
          Sign in with your Xero account. (MYOB and QuickBooks sign-in coming soon.)
        </p>

        <a
          href={`${API_BASE}/api/xero/login`}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            width: '100%',
            padding: '14px 24px',
            background: T.xeroBlue,
            color: '#FFFFFF',
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 600,
            fontFamily: "'Geist', sans-serif",
            textDecoration: 'none',
            transition: 'opacity 150ms ease',
            border: 'none',
            cursor: 'pointer',
            boxSizing: 'border-box',
          }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.opacity = '0.9'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.opacity = '1'; }}
        >
          <XeroX size={18} color="#FFFFFF" />
          Login with Xero
        </a>
      </div>
    </div>
  );
}
